export default __webpack_public_path__ + "static/media/Li.7aa32ede.svg";